export default __webpack_public_path__ + "static/1330-be05f069a4d63cce0271c2421248a16f.gif";